<template>
        <div>
            <p>*Earnings may take up to 2 billing cycles to add to your account. Valid one time only.This rewards program is provided by Ulta Beauty<sup>&#174;</sup> and its terms may change at any time. For full Rewards Terms and Conditions, please see <a href="http://beyondultabeautyrewards.com" target="_blank">Beyond Ulta Beauty Rewards</a>.</p>
            <p class="mt-10">Credit card offers are subject to credit approval.<br>Ulta Beauty Rewards<sup>&#8482;</sup> Mastercard<sup>&#174;</sup> Credit Card Accounts are issued by Comenity Capital Bank pursuant to a license from Mastercard International Incorporated. Mastercard and the circles design are registered trademarks of Mastercard International Incorporated</p>
        </div>
</template>

<script>
export default {
    name: "PreLoginDisclosure"
}
</script>
<style scoped>
    div {
        max-width: 700px;
        text-align: left;
        margin: 0 auto;
    }
    p {
        color: #444;
        font-size: 14px;
    }
    a {
        color: #007BFF;
    }
</style>
